import Title from "antd/es/typography/Title";
import {Alert, Button, Flex, Typography} from "antd";
import {Utils} from "../../../../services/Utils";
import {PracticeProgressStatus, PracticeType} from "../../../../models/Practice/Practice";
import {PracticeDetail} from "../../../../models/Practice/PracticeDetail";
import {useTranslation} from "react-i18next";
import {UploadVouchers} from "./UploadVouchers/UploadVouchers";
import {UploadFilesLiquidation} from "./UploadFilesLiquidation/UploadFilesLiquidation";
import React, {useEffect, useState} from "react";
import {PracticeFileRow} from "../../../../models/Practice/PracticeFIle";
import {PracticesHttpService} from "../../../../services/Http/PracticesHttpService";
import {useParams} from "react-router-dom";
import {UploadFilesWarrantyActivation} from "./UploadFilesWarrantyActivation/UploadFilesWarrantyActivation";
import {LoadedFilesTable} from "./LoadedFilesTable/LoadedFilesTable";
import {NotificationService} from "../../../../services/NotificationService";
import {saveFile} from "../../../../utils/files";
import {Employee} from "../../../../models/Auth/Employee";
import {AuthService} from "../../../../services/AuthService";
import {InsuranceProviderIntegrationCodes} from "../../../../models/InsuranceProvider";
import {isNil} from "lodash";

export interface DetailPartProps {
    practiceDetail: PracticeDetail;
    changeVisus?: string,
    refundConditions?: string,
    onClickSavePurchase:() => void;
    onClickConfirmDocs:() => void;
    reloadDetail: (showNoteWarning?: boolean) => Promise<void>;
    onSaveFile: () => void;
    attachedFiles: Array<PracticeFileRow>;
    handleMiddleColumnSpin:(value:boolean)=>void;
}

export function DetailPart(props: DetailPartProps) {
    const { Text } = Typography;
    const { t, i18n } = useTranslation();
    const { id } = useParams();

    const insuranceProvider = props.practiceDetail.insuranceProvider;
    const convention = insuranceProvider.description;
    const progress = props.practiceDetail.progress;

    const manage = props.practiceDetail.agreement;
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const INSURANCE_PROVIDERS_FOR_AMEND = [
        'INSALUTE',
        'BLUE',
        'PREV',
        'CASP',
        'POSTE'
    ];

    const showAmendButton = [
        PracticeProgressStatus.DOCUMENTAZIONE_INVIATA,
        PracticeProgressStatus.PIC_AUTORIZZATA
    ].includes(props.practiceDetail.status) &&
        INSURANCE_PROVIDERS_FOR_AMEND.includes(props.practiceDetail.insuranceProvider.code); // <--- Using practiceDetail.status here

    const handleAmend = async () => {
        setIsLoading(true);
        let operator:Employee|null = AuthService.getOperatorOnline();
        try {
            const response = await PracticesHttpService.amendDocument(String(props.practiceDetail.id),{
                metadata: { operator:operator?.name ?? "" },
                event: "ERRORE_IN_DOCUMENTAZIONE"
            });

            if (response.status >= 200 && response.status < 300) {
                await props.reloadDetail();
                //props.onSaveFile();
                NotificationService.getInstance().openNotificationSuccess("Rettifica", "Documento rettificato con successo!");
            }
            console.log(response.status);
        }finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        props.onSaveFile();
    }, []);

    const currentIntegrationCode = props.practiceDetail.insuranceProvider.integrationCode;
    const isAxaProvider = currentIntegrationCode === InsuranceProviderIntegrationCodes.AXA.toString();
    const lastPracticeProgress = Utils.getLastProgressData(progress);

    const isDisableFilesLiquidationButton = () => {
        let foundPicAuth = Utils.getProgressData(PracticeProgressStatus.PIC_AUTORIZZATA, progress); // || Utils.getProgressData(PracticeProgressStatus.PRESO_APPUNTAMENTO, progress);
        let foundAttachedDoc = Utils.getProgressData(PracticeProgressStatus.DOCUMENTAZIONE_INVIATA, progress);
        let foundAttachedDocToSend = Utils.getProgressData(PracticeProgressStatus.DOCUMENTAZIONE_DA_INVIARE, progress);
        let foundErrorInInvoice = Utils.getProgressData(PracticeProgressStatus.ERRORE_IN_FATTURA, progress);
        const providersToCheck = [InsuranceProviderIntegrationCodes.ISP.valueOf(), InsuranceProviderIntegrationCodes.AON.valueOf()];
        let checkInsurance = providersToCheck.includes(insuranceProvider.code) || !isNil(foundAttachedDoc);
        const enableForAxa = isAxaProvider && (!isNil(foundAttachedDoc) || !isNil(foundAttachedDocToSend) || !isNil(foundErrorInInvoice));
        return !((foundPicAuth && checkInsurance) || enableForAxa);
    };

    const deleteFile = async (attachmentId:number) => {
        try {
            await PracticesHttpService.deletePracticeFile(id,attachmentId)
            props.onSaveFile();
        } catch (error) {
            console.error(error);
            NotificationService.getInstance().openNotificationError("Impossibile cancellare l'allegato");
        }
    };

    const downloadFile = async (attachmentId: number, filename: string) => {
        try {
            const response = await PracticesHttpService.downloadPracticeFile(id,attachmentId)
            saveFile(response.data, filename);
        } catch (e) {
            console.error(e);
            NotificationService.getInstance().openNotificationError("Impossibile scaricare l'allegato");
        }
    };

    const detail = () => {
        if (manage === PracticeType.DIRECT) {
            const isDisable:boolean = isDisableFilesLiquidationButton();

            return <>
                <Flex wrap="wrap" gap="middle">
                    <Flex vertical className={"labels width-40"}>
                        <Text strong>Stato PIC</Text>
                        <Text>{props.practiceDetail.picStatus}</Text>
                    </Flex>
                    <Flex vertical className={"labels width-40"}>
                        <Text strong>Numero PIC</Text>
                        <Text>{props.practiceDetail.picNumber}</Text>
                    </Flex>
                </Flex>

                {insuranceProvider.code !== InsuranceProviderIntegrationCodes.ISP.valueOf() && <Alert className={'alert-box'}  message={t("directInsuranceDepositLimit")} type="warning" /> }

                <UploadFilesWarrantyActivation practiceDetail={props.practiceDetail}
                                               convention={convention}
                                               insuranceProvider={insuranceProvider}
                                               onClickConfirmDocs={props.onClickConfirmDocs}
                                               files={props.attachedFiles}
                                               loadFiles={props.onSaveFile}
                                               progress={progress}
                                               reloadDetail={props.reloadDetail}
                                               handleMiddleColumnSpin={(value:boolean) => props.handleMiddleColumnSpin(value)}
                />
                <Flex style={{width: "100%"}}>
                    <UploadFilesLiquidation practiceDetail={props.practiceDetail}
                                            files={props.attachedFiles}
                                            loadFiles={props.onSaveFile} disableButtons={isDisable}
                                            progress={progress} status={props.practiceDetail.status}
                                            reloadDetail={props.reloadDetail}
                    />
                </Flex>
                {showAmendButton ?
                    <Flex gap={"small"} className={"margin-y-10px"}>
                        <Button
                            key="upload"
                            type="primary"
                            onClick={handleAmend}
                            disabled={!showAmendButton || isLoading}
                        >
                            {isLoading ? 'Rettifica in corso...' : 'Rettifica Pratica'}
                        </Button>
                    </Flex>
                    :
                    undefined
                }
                <Text strong>Documenti caricati </Text>
                <LoadedFilesTable practiceDetail={props.practiceDetail}
                                  state={props.practiceDetail.status}
                                  claimStatus={props.practiceDetail.claimStatus}
                                  progress={progress}
                                  files={props.attachedFiles}
                                  deleteFileCallback={deleteFile}
                                  downloadFileCallback={downloadFile} />
            </>
        } else if (manage === PracticeType.INDIRECT) {
            return <>
                <Flex gap="middle">
                    <Flex vertical className={"labels"} style={{flex: 1}}>
                        <Text strong>Cambio visus</Text>
                        <Text>{props.changeVisus || "-"}</Text>
                    </Flex>
                    <Flex vertical className={"labels"} style={{flex: 1}}>
                        <Text strong>Condizioni di rimborso</Text>
                        <Text style={{whiteSpace: "pre-line"}}>{props.refundConditions || "-"}</Text>
                    </Flex>
                </Flex>
                <UploadVouchers agreement={props.practiceDetail.agreement}
                                status={props.practiceDetail.status}
                                claimStatus={props.practiceDetail.claimStatus}
                                progress={progress}
                                invoiceUploaded={false}
                                onClickSavePurchase={props.onClickSavePurchase}/>
            </>
        } else
            return <></>
    }

    return <div className={"practices-details-columns"}>
        <Flex vertical className={"labels width-100"}>
            <Text strong>Negozio</Text>
            <Text>{props.practiceDetail.shopName}</Text>
        </Flex>
        <Title level={5} className={"title"}>Dati assicurativi</Title>
        <Flex wrap="wrap" gap={"middle"}>
            <Flex vertical className={"labels width-20"}>
                <Text strong>Convenzione</Text>
                <Text>{convention}</Text>
            </Flex>
            <Flex vertical className={"labels width-20"}>
                <Text strong>Gestione</Text>
                <Text>{t(manage || "")}</Text>
            </Flex>
            <Flex vertical className={"labels width-20"}>
                <Text strong>Data voucher</Text>
                <Text>{Utils.getDateItFormat(props.practiceDetail.voucherDate)}</Text>
            </Flex>
            <Flex vertical className={"labels width-20"}>
                <Text strong>Stato</Text>
                <Text>{t(props.practiceDetail.claimStatus)}</Text>
            </Flex>
        </Flex>
        { detail() }
    </div>
}
